import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {ColectorService} from "saneamiento/service";
import {colector_view_adapter} from "saneamiento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {ColectorForm} from "../presentational/form";

const UpdateColectorPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let colector;
    [colector] = useOutletContext();

    const handleSubmit = colector => {
        ColectorService.update(colector_view_adapter({...colector}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <ColectorForm
                    colector={colector}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar Colector"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdateColectorPanel;
